import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

function HelpContent(helpvar) {
    switch(helpvar) {
        case 'clds':
            return (
                <>                
                    <Typography variant="subtitle">Cloud Condition Codes</Typography>
                    <Typography variant="body2" sx={{ mt: 1, mb: 1}}>Since up to 3 cloud layers can be reported, the 
                        full state of the sky can best be determined by the last layer's value. In other words, 
                        if three layers are reported and the third layer uses BKN, then the total state of sky is BKN. 
                        In cases where there are more than 3 cloud layers, the highest layers will not be reported.
                    </Typography>
                    <ul style={{ marginTop: 0, listStyle: "none", paddingLeft: "1em", fontSize: "85%" }}>
                        <li>CLR = Clear skies (SKC or CLR)</li>
                        <li>FEW = 1/8 to 2/8 of sky covered by clouds (“partly cloudy")</li>
                        <li>SCT = 3/8 to 4/8 covered (“partly cloudy")</li>
                        <li>BKN = 5/8 to 7/8 covered (“mostly cloudy")</li>
                        <li>OVC = 8/8 (sky completely covered - “cloudy” or "overcast")</li>
                        <li>VV =  Sky obscured or cloud amount cannot be estimated</li>
                        <li>X =   Partial obscuration</li>
                    </ul>
                    <Typography variant="body2" sx={{ mt: 1, mb: 1}}>Value after cloud coverage is base height of that cloud 
                        layer in hundreds of feet. For example, BKN035 indicates a broken cloud layer 3500 feet.
                    </Typography>
                 </> 
            )
        case "wx": 
            return (
                <Box>                
                    <Typography variant="subtitle">Present Weather Codes</Typography>
                    <Typography variant="body2" sx={{ mt: 1, mb: 1}}>Codes can be a sequential order/combination of several sub-codes for weather intensity,
                        descriptor, precipitation, obscuration and other:</Typography>
                    <Stack
                        direction={{ sm: 'column', md: 'row' }}
                        spacing={4}
                        divider={<Divider orientation="vertical" flexItem />}
                        sx={{
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            fontSize: "85%",
                        }}
                    >  
                        <Box>
                            Intensity:
                            <ul style={{ marginTop: 0, listStyle: "none", paddingLeft: "1em" }}>
                                <li>- = light</li>
                                <li>+ = heavy</li>
                                <li>VC = vicinity (apparent but not at point of observation)</li>
                            </ul>
                            Descriptor:
                            <ul style={{ marginTop: 0, listStyle: "none", paddingLeft: "1em" }}>
                                <li>MI = shallow</li>
                                <li>PR = partial</li>
                                <li>BC = patches</li>
                                <li>DR = low drifting</li>
                                <li>BL = blowing</li>
                                <li>SH = showers</li>
                                <li>TS = thunderstorm</li>
                                <li>FZ = freezing or frozen</li>
                            </ul>
                        </Box>
                        <Box>
                            Precipitation:
                            <ul style={{ marginTop: 0, listStyle: "none", paddingLeft: "1em" }}>
                                <li>DZ = Drizzle</li>
                                <li>RA = Rain</li>
                                <li>SN = Snow</li>
                                <li>SG = Snow Grains</li>
                                <li>IC = Ice Crystals</li>
                                <li>PL = Ice Pellets (sleet)</li>
                                <li>GR = Hail</li>
                                <li>GS = Small Hail and/or Snow Pellets</li>
                                <li>UP = Unknown Precipitation</li>
                            </ul>
                            Obscuration:
                            <ul style={{ marginTop: 0, listStyle: "none", paddingLeft: "1em" }}>
                                <li>BR = Mist</li>
                                <li>FG = Fog</li>
                                <li>FU = Smoke</li>
                                <li>VA = Volcanic Ash</li>
                                <li>DU = Widesprea Dust</li>
                                <li>SA = Sand</li>
                                <li>HZ = Haze</li>
                                <li>PY = Spray</li>
                            </ul>
                            Other weather:
                            <ul style={{ marginTop: 0, listStyle: "none", paddingLeft: "1em" }}>
                                <li>PO = Well-developed dust/sand whirls</li>
                                <li>SQ = Squalls</li>
                                <li>FC = Funnel Cloud (Waterspout or Tornado)</li>
                                <li>SS = Sandstorm</li>
                                <li>DS = Duststorm</li>
                            </ul>
                        </Box>
                    </Stack> 
                </Box> 
            )
        default:
            return ("Help not available for this variable.")
    }
};

export default function Help(props) {
    const { variable } = props;

    return (
        <Box sx={{ px:2, pt:1, border: "1px solid #9e9e9e", marginLeft: "10%", marginRight: "10%", marginBottom: 1 }}>
            {HelpContent(variable)}
        </Box>
    )
};
